module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "正常"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "隐藏"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "kaojicenter-list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "kaojicenter-lists flex-between",
      on: {
        "click": function($event) {
          return _vm.action(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "kaojicenter-rights"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "desc flex-start"
    }, [(item.cert_status == 1) ? _c('van-tag', {
      attrs: {
        "round": "",
        "type": "success"
      }
    }, [_vm._v("已认证")]) : (item.cert_status == 3) ? _c('van-tag', {
      attrs: {
        "round": ""
      }
    }, [_vm._v("认证失败")]) : (item.cardtype == 1 && item.cert_status == 2) ? _c('van-tag', {
      attrs: {
        "round": "",
        "type": "warning"
      }
    }, [_vm._v("未认证")]) : (item.cardtype != 1 && item.cert_status == 2) ? _c('van-tag', {
      attrs: {
        "round": "",
        "plain": ""
      }
    }, [_vm._v("无需认证")]) : _vm._e(), _vm._v("   \n                                 " + _vm._s(item.num) + "\n                            ")], 1)])])
  }), 0)])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "bottom": "80px",
      "right": "10px",
      "position": "fixed"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onTongbu
    }
  }, [_vm._v("同步CCA官网\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        _vm.addShow = true
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '60%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("新增裁判员")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.cardtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.cardtype == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.cardtype != 1) ? _c('van-field', {
    attrs: {
      "label": "证件号码",
      "rules": [{
        required: true,
        message: '证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.huzhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "huzhao", $$v)
      },
      expression: "formData.huzhao"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "手机",
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "验证码",
      "rules": [{
        required: true,
        message: '请输入验证码'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary",
            "disabled": _vm.clockSecond > 0
          },
          on: {
            "click": _vm.getCode
          }
        }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
          '(' + _vm.clockSecond + 's)' : '获取验证码'))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "QQ",
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入QQ"
    },
    model: {
      value: (_vm.formData.qq),
      callback: function($$v) {
        _vm.$set(_vm.formData, "qq", $$v)
      },
      expression: "formData.qq"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "微信",
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入微信"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  })], 1), _vm._v(" "), _c('IdCardPicker', {
    staticStyle: {
      "margin": "0 auto",
      "margin-top": "20px",
      "width": "4rem",
      "text-align": "center",
      "border-radius": "1rem",
      "border": "1px solid #eee",
      "line-height": "0.6rem"
    },
    on: {
      "success": _vm.onIdSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0fc9e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/member/CaipanList.vue
// module id = 2296
// module chunks = 0